import {CustomRoutePre as CustomPre, CustomRoutePost as CustomPost } from './Custom';

export const CustomRoutePre = [
  ...(CustomPre || []),
]

export const CustomRoutePost = [
  ...(CustomPost || []),
]

export const SuppressGenRoute = false;


// WEBPACK FOOTER //
// ./src/pages/CustomRoute.js